import { render } from "./AlarmDestinationsSettings.vue?vue&type=template&id=6901347c"
import script from "./AlarmDestinationsSettings.vue?vue&type=script&lang=js"
export * from "./AlarmDestinationsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__